/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import { OPEN_MODAL, CLOSE_MODAL } from 'state/action-types';

const namedReducer = (state = { isVisible: false, data: {} }, action) => {
    switch (action.type) {
        case OPEN_MODAL:
            return {
                ...state,
                isVisible: true,
                data: get(action, 'payload.data', {}),
            };
        case CLOSE_MODAL:
            return {
                ...state,
                isVisible: false,
                data: {},
            };
        default:
            return state;
    }
};

const modalReducer = (state = {}, action) => {
    const name = get(action, ['meta', 'modal', 'name'], false);
    if (name) {
        switch (action.type) {
            case CLOSE_MODAL:
            case OPEN_MODAL:
                return {
                    ...state,
                    ...{
                        [name]: namedReducer(state[name], action),
                    },
                };
            default:
            	return state;
        }
    }

    return state;
};

export default modalReducer;
